import SiteHeader from './components/SiteHeader';
import Hero from './components/Hero';
import FactsSection from './components/FactsSection';
import PlotSection from './components/PlotSection';
import CastSection from './components/CastSection';
import SeriesSection from './components/SeriesSection';
import ScenesSection from './components/ScenesSection';
import SimilarSection from './components/SimilarSection';
import GuideSection from './components/GuideSection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <div className="min-h-screen w-full bg-background-50">
      <SiteHeader />
      <main className="w-full">
        <Hero />
        <FactsSection />
        <PlotSection />
        <CastSection />
        <SeriesSection />
        <ScenesSection />
        <SimilarSection />
        <GuideSection />
        <FaqSection />
      </main>
      <SiteFooter />
    </div>
  );
}